/**
 * User: Faris
 * Date: 6/24/13
 * Time: 4:30 PM
 */

define('app/views/footer',[], function() {

  return Backbone.View.extend({

    initialize: function(){
    }

  });

});
